<svg [class]="'transition-icon rotate-'+rotate+' '+svgClassName" [attr.width]="width" [attr.height]="height" id="svg-image"
[attr.viewBox]="'0 0 '+width+' '+height" xmlns="http://www.w3.org/2000/svg">
    <use [class]="className " [attr.xlink:href]="baseUrl+value+'.svg#'+(id || value)"
        [attr.href]="baseUrl+value+'.svg#'+(id || value)" [attr.stroke]="stroke" [attr.fill]="fill" />
</svg>